module.exports = __webpack_public_path__ + "img/6.278d7eb8.png";